const createFunctionWithTimeout = (callback, opt_timeout = 1000) => {
  let called = false;
  const raceCallback = () => {
    if (!called) {
      called = true;
      callback();
    }
  };
  setTimeout(raceCallback, opt_timeout);
  return raceCallback;
};

export const getTracker = () =>
  new Promise((resolve, reject) => {
    if (!window.ga) {
      reject();
      console.warn("[GA] Not activated in production");
    } else {
      console.log("[GA] Waiting to get Tracker ID...");
      window.ga((tracker) => {
        console.log("[GA] Tracker ID fetched");
        resolve(tracker);
      });
      setTimeout(reject, 1000);
    }
  });

export const track = ({
  category,
  action,
  label,
  value,
  nonInteraction = false,
  transport,
  hitCallback,
  callbackTimeout = 1000,
}) => {
  if (typeof window !== `undefined` && window.ga) {
    const trackingEventOptions = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      nonInteraction: nonInteraction,
      transport,
    };

    if (hitCallback && typeof hitCallback === `function`) {
      trackingEventOptions.hitCallback = createFunctionWithTimeout(
        hitCallback,
        callbackTimeout
      );
    }

    console.log("[GA] Send event trackingEventOptions");
    window.ga(`send`, `event`, trackingEventOptions);
  }
};
